import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../lib/api';

export function useUsers(page = 1, perPage = 50) {
  return useQuery({
    queryKey: ['users', page, perPage],
    queryFn: () => adminApi.users.list({ page, per_page: perPage }),
  });
}

export function useUser(id: string) {
  return useQuery({
    queryKey: ['users', id],
    queryFn: () => adminApi.users.get(id),
    enabled: Boolean(id),
  });
}
